angular.module('edxComponents')
  .component('edxQuantileMeasureDropdown', {
    templateUrl: 'resources/components/assign-focus/create-quantile-assignment/quantile-measure-dropdown.component.html',
    controller: ['edxQuantileAssignmentService', QuantileMeasureDropdownController],
    controllerAs: 'vm',
    bindings: {
      studentId: '<edxStudentId',
      levelId: '<edxLevelId',
      onSelect: '&edxOnSelect',
      disabled: '<edxDisabled',

    }
  });

function QuantileMeasureDropdownController(quantileAssignmentService) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.$onChanges = $onChanges;
  vm.isDisabled = isDisabled;
  vm.onClick = onClick;

  vm.loading = false;
  vm.measures = [];
  vm.selected = undefined;

  var lastSentValue;

  function $onChanges(changes) {
    if (changes.studentId) {
      sendSelectionIfChanged(vm.selected);
    }
  }

  function $onInit() {
    vm.loading = true;
    
    vm.selected = undefined;
    
    quantileAssignmentService.loadMeasuresForStudent(vm.studentId).then(function (measures) {
        vm.measures = measures || [];
    }).catch(function () {
        vm.measures = [];
    }).finally(function () {
        vm.loading = false;
    });
  }


  function isDisabled() {
    return vm.disabled || vm.loading;
  }

  function onClick(model) {
    sendSelectionIfChanged(model);
  }

  function sendSelectionIfChanged(model) {
    if (lastSentValue !== model) {
      lastSentValue = model;
      vm.onSelect({measure: model});
    }
  }
}
